export default __webpack_public_path__ + "static/media/scroll.8aef4363.svg";